export const pieceKeys = {
  r: "rook",
  n: "knight",
  b: "bishop",
  q: "queen",
  k: "king",
  p: "pawn"
}

export const colorKeys = {
  b: "black",
  w: "white"
}